import React from 'react';
import TauriAccordionAttachments from '../TauriAccordionAttachments/TauriAccordionAttachments';
import OpalSamples from '../OpalSamples/OpalSamples';
import OpalReminder from '../OpalReminder/OpalReminder';
import OpalInventory from '../OpalInventory/OpalInventory';
import OpalWithdrawal from '../OpalWithdrawal/OpalWithdrawal';
import OpalContextualActivity from '../OpalContextualActivity/OpalContextualActivity';
import OpalEvaluation from '../OpalEvaluation/OpalEvaluation';
import OpalOrders from '../OpalOrders/OpalOrders';

const OpalCoverageFactory = ({ section, id, session }) => {
    if (!section.show) return null;
    
    switch (section.type) {
        case "file":
            return <TauriAccordionAttachments section={section} id={id} />;
        case "samples":
            return <OpalSamples section={section} id={id} />;
        case "reminder":
            return <OpalReminder section={section} id={id} />;
        case "inventory":
            return <OpalInventory section={section} id={id} />;
        case "withdrawal":
            return <OpalWithdrawal section={section} id={id} />;
        case "order":
            return <OpalOrders section={section} id={id} />;
        case "contextual":
            return <OpalContextualActivity section={section} id={id} session={session} />;
        case "evaluation":
            return <OpalEvaluation section={section} id={id} />;
        default:
            return null; // Handle unknown types
    }
};

export default OpalCoverageFactory;